import React from 'react';
import { motion } from 'framer-motion';
import './LoadingSpinner.css';

/**
 * Loading spinner component with animated effects
 */
const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <motion.div
        className="loading-spinner"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
      >
        {/* Main spinner */}
        <div className="spinner-ring">
          <div className="spinner-ring-inner"></div>
        </div>

        {/* Orbiting dots */}
        <div className="spinner-orbit">
          <div className="orbit-dot"></div>
          <div className="orbit-dot"></div>
          <div className="orbit-dot"></div>
        </div>

        {/* Center icon */}
        <div className="spinner-center">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 2L2 7L12 12L22 7L12 2Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 17L12 22L22 17"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 12L12 17L22 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </motion.div>

      <motion.div
        className="loading-text"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <span className="loading-title">Fetching player data</span>
        <span className="loading-dots">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </motion.div>
    </div>
  );
};

export default LoadingSpinner;
